import { includes } from 'lodash';
import type { ReactNode } from 'react';
import type { To } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { Box } from '@hivebrite/design-system/Box';
import type { BoxProps } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import type { ButtonSizeByKeyname } from '@hivebrite/design-system/Button';
import {
  FontAwesomeIcon,
  CATEGORIES,
} from '@hivebrite/design-system/FontAwesomeIcon';
import { useBreakpoint } from '@hivebrite/design-system/Theme';
import type { UseBreakpointProps } from '@hivebrite/design-system/Theme';

interface GoBackButtonProps {
  url?: To | number;
  size?: ButtonSizeByKeyname;
  children?: ReactNode;
}

const GO_BACK = -1;

const GoBackNavigation = ({
  url = GO_BACK,
  hiddenBreakpoints = ['s'],
  size,
  children,
  ...otherProps
}: GoBackButtonProps & {
  hiddenBreakpoints?: UseBreakpointProps[];
} & BoxProps) => {
  const breakpoint = useBreakpoint();

  if (includes(hiddenBreakpoints, breakpoint)) {
    return null;
  }

  return (
    <Box mx={7} my={6} {...otherProps}>
      <GoBackButton url={url} size={size}>
        {children}
      </GoBackButton>
    </Box>
  );
};

export const GoBackButton = ({
  url = GO_BACK,
  children,
  size,
}: GoBackButtonProps) => {
  const navigate = useNavigate();

  return (
    <Button
      onClick={() => navigate(url as any)}
      variant="secondary"
      icon={() => (
        <FontAwesomeIcon
          iconName="chevron-left"
          height="16px"
          iconType={CATEGORIES.SOLID}
        />
      )}
      size={size}
    >
      {children ?? __('Go back')}
    </Button>
  );
};

export default GoBackNavigation;
